import axios from 'axios';
import { useEffect, useState } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { v4 as uuidv4 } from 'uuid';
import './MentorForm.css';

// const BASE_URL = "http://localhost:8000";
const BASE_URL = "https://idealpursuits.co.in/api";

function EditMentorForm({ mentor, onSubmit, onClose }) {
  const [selectedImage, setSelectedImage] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    mentorId: mentor.mentorId,
    name: mentor.name,
    email: mentor.email,
    password: mentor.password,
    meetingCharge: mentor.meetingCharge,
    phone: mentor.phone,
    address: mentor.address || '',
    profession: mentor.profession || '',
    category: mentor.category || '',
    experience: mentor.experience || '',
    qualifications: mentor.qualifications || '',
    resumeDocName: '',
    proofDocName: '',
    profileImageName: '',
    newResumeDocName: '',
    newProofDocName: '',
    newProfileImageName: '',
    resumeDoc: null,
    proofDoc: null,
    profileImage: null,
    isApproved: mentor.isApproved || false
  });

  useEffect(() => {
    // Update form data if mentor prop changes
    setFormData({
      mentorId: mentor.mentorId,
      name: mentor.name,
      email: mentor.email,
      password: mentor.password,
      meetingCharge: mentor.meetingCharge,
      phone: mentor.phone,
      address: mentor.address || '',
      profession: mentor.profession || '',
      category: mentor.category || '',
      experience: mentor.experience || '',
      qualifications: mentor.qualifications || '',
      resumeDocName: mentor.resumeDocName || '',
      proofDocName: mentor.proofDocName || '',
      profileImageName: mentor.profileImageName || '',
      newResumeDocName: '',
      newProofDocName: '',
      newProfileImageName: '',
      resumeDoc: null,
      proofDoc: null,
      profileImage: null,
      isApproved: mentor.isApproved || false
    });
  }, [mentor]);

  const handleImageClick = (imageSrc) => {
    setSelectedImage(imageSrc);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleResumeFileChange = (e) => {
    const { files } = e.target;

    // Generate a smaller UUID
    const smallUUID = uuidv4().slice(0, 8); // Adjust length as needed

    setFormData((prev) => ({
      ...prev,
      ['resumeDoc']: files[0],
      [`newResumeDocName`]: `${smallUUID}_${files[0].name}`, // Dynamically set doc name based on input name
    }));
  };
  const handleProofFileChange = (e) => {
    const { files } = e.target;

    // Generate a smaller UUID
    const smallUUID = uuidv4().slice(0, 8); // Adjust length as needed

    setFormData((prev) => ({
      ...prev,
      ['proofDoc']: files[0],
      [`newProofDocName`]: `${smallUUID}_${files[0].name}`, // Dynamically set doc name based on input name
    }));
  };

  const handleProfileFileChange = (e) => {
    const { files } = e.target;

    // Generate a smaller UUID
    const smallUUID = uuidv4().slice(0, 8); // Adjust length as needed

    setFormData((prev) => ({
      ...prev,
      ['profileImage']: files[0],
      [`newProfileImageName`]: `${smallUUID}_${files[0].name}`, // Dynamically set doc name based on input name
    }));
  };

  const handleApprovedToggle = async () => {
    const updatedApprovalStatus = !formData.isApproved;

    try {
      const response = await axios.put(`${BASE_URL}/mentor/approveMentorDetails.php`, {
        mentorId: formData.mentorId,
        email: formData.email,
        name: formData.name,
        isApproved: updatedApprovalStatus, // Send the updated status
      });

      if (response.data.success) {
        // Update the form data locally after server confirmation
        setFormData((prev) => ({
          ...prev,
          isApproved: updatedApprovalStatus,
        }));
      } else {
        console.error("Failed to toggle approval:", response.data.error);
      }
    } catch (error) {
      console.error("Error toggling approval:", error);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const submissionData = new FormData();
    Object.keys(formData).forEach(key => {
      submissionData.append(key, formData[key]);
    });

    onSubmit(submissionData);
  };

  return (
    <div className="mentor-form-overlay">
      <div className="mentor-form">
        <span className="close" onClick={onClose}>&times;</span>
        <h2>Edit Mentor Details</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Name:</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="form-group">
            <label>Email:</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="form-group">
            <label>Password</label>
            <div className="email-verify">
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                name="password"
                value={formData.password}
                onChange={handleInputChange}
                placeholder="Enter your password"
                required
              />
              <button
                type="button"
                className="show-password-btn"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>
          </div>
          <div className="form-group">
            <label>Phone:</label>
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="form-group">
            <label>Address:</label>
            <textarea
              name="address"
              value={formData.address}
              onChange={handleInputChange}
            />
          </div>
          <div className="form-group">
            <label>Meeting Charge:</label>
            <input
              type="number"
              name="meetingCharge"
              value={formData.meetingCharge}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="form-group">
            <label>Profession:</label>
            <input
              type="text"
              name="profession"
              value={formData.profession}
              onChange={handleInputChange}
            />
          </div>
          <div className="form-group">
            <label>Category:</label>
            <input
              type="text"
              name="category"
              value={formData.category}
              onChange={handleInputChange}
            />
          </div>
          <div className="form-group">
            <label>Experience:</label>
            <textarea
              name="experience"
              value={formData.experience}
              onChange={handleInputChange}
            />
          </div>
          <div className="form-group">
            <label>Qualifications:</label>
            <textarea
              name="qualifications"
              value={formData.qualifications}
              onChange={handleInputChange}
            />
          </div>
          <div className="form-group">
            <label>Resume Document:</label>
            {mentor.resumeDocName && (
              <>
                {['png', 'jpeg', 'jpg'].some(ext => mentor.resumeDocName.endsWith(ext)) ? (
                  <img
                    src={`${BASE_URL}/images/resume/${mentor.resumeDocName}`}
                    alt="Resume Preview"
                    className="image-preview"
                    onClick={() => handleImageClick(`${BASE_URL}/images/resume/${mentor.resumeDocName}`)}
                  />
                ) : (
                  <a
                    href={`${BASE_URL}/images/resume/${mentor.resumeDocName}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    View Document
                  </a>
                )}
              </>
            )}
            <input
              type="file"
              name="resumeDoc"
              onChange={handleResumeFileChange}
              accept=".png,.jpeg,.jpg,.pdf,.doc"
            />
          </div>

          <div className="form-group">
            <label>Proof Document:</label>
            {mentor.proofDocName && (
              <>
                {['png', 'jpeg', 'jpg'].some(ext => mentor.proofDocName.endsWith(ext)) ? (
                  <img
                    src={`${BASE_URL}/images/proof/${mentor.proofDocName}`}
                    alt="Proof Preview"
                    className="image-preview"
                    onClick={() => handleImageClick(`${BASE_URL}/images/proof/${mentor.proofDocName}`)}
                  />
                ) : (
                  <a
                    href={`${BASE_URL}/images/proof/${mentor.proofDocName}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    View Document
                  </a>
                )}
              </>
            )}
            <input
              type="file"
              name="proofDoc"
              onChange={handleProofFileChange}
              accept=".png,.jpeg,.jpg,.pdf,.doc"
            />
          </div>

          <div className="form-group">
            <label>Profile Image:</label>
            {mentor.profileImageName && (
              <>
                {['png', 'jpeg', 'jpg'].some(ext => mentor.profileImageName.endsWith(ext)) ? (
                  <img
                    src={`${BASE_URL}/images/profile/${mentor.profileImageName}`}
                    alt="Profile Preview"
                    className="image-preview"
                    onClick={() => handleImageClick(`${BASE_URL}/images/profile/${mentor.profileImageName}`)}
                  />
                ) : (
                  <a
                    href={`${BASE_URL}/images/profile/${mentor.profileImageName}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    View Document
                  </a>
                )}
              </>
            )}
            <input
              type="file"
              name="profileImage"
              onChange={handleProfileFileChange}
              accept=".png,.jpeg,.jpg,.pdf,.doc"
            />
          </div>
          {/* Modal for Full Image */}
          {selectedImage && (
            <div className="image-modal-overlay" onClick={closeModal}>
              <div className="image-modal-content">
                <img src={selectedImage} alt="Full View" className="full-image" />
              </div>
            </div>
          )}<div className="form-group">
            <label>Approved:</label>
            <div className="toggle-container">
              <label className="switch">
                <input
                  type="checkbox"
                  checked={formData.isApproved}
                  onChange={handleApprovedToggle}
                />
                <span className="slider round"></span>
              </label>
            </div>
          </div>
          <button type="submit">Update Mentor</button>
        </form>
      </div>
    </div>
  );
}

export default EditMentorForm;